module.exports = __webpack_public_path__ + "img/cikd_wechat.a6f7805c.jpg";